import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private readonly translate = inject(TranslateService);

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.getAndInitTranslations();
    });
    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.translate.get([
      'PAGINATOR.ITEMS_PER_PAGE_LABEL',
      'PAGINATOR.NEXT_PAGE_LABEL',
      'PAGINATOR.PREVIOUS_PAGE_LABEL',
      'PAGINATOR.FIRST_PAGE_LABEL',
      'PAGINATOR.LAST_PAGE_LABEL',
      'PAGINATOR.RANGE_LABEL'
    ]).subscribe(translations => {
      this.itemsPerPageLabel = translations['PAGINATOR.ITEMS_PER_PAGE_LABEL'];
      this.nextPageLabel = translations['PAGINATOR.NEXT_PAGE_LABEL'];
      this.previousPageLabel = translations['PAGINATOR.PREVIOUS_PAGE_LABEL'];
      this.firstPageLabel = translations['PAGINATOR.FIRST_PAGE_LABEL'];
      this.lastPageLabel = translations['PAGINATOR.LAST_PAGE_LABEL'];

      const rangeLabelTemplate = translations['PAGINATOR.RANGE_LABEL'];
      this.getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
          return rangeLabelTemplate
            .replace('{{start}}', '0')
            .replace('{{end}}', '0')
            .replace('{{length}}', '0');
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
        return rangeLabelTemplate
          .replace('{{start}}', (startIndex + 1).toString())
          .replace('{{end}}', endIndex.toString())
          .replace('{{length}}', length.toString());
      };
      this.changes.next();
    });
  }
}

export const provideCustomPaginatorIntl = () => ({
  provide: MatPaginatorIntl,
  useClass: CustomMatPaginatorIntl
});

